import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";


export default function LoginPage() {

  const { login } = useAuth();
  const navigate = useNavigate();


  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");



  async function handleLogin(e) {

    e.preventDefault();

    setError("");


    if (!email || !password) {

      setError("Fyll i e-post och lösenord.");
      return;

    }



    try {

      setLoading(true);


      await login(email, password);


      // Efter lyckad inloggning
      navigate("/intern", { replace: true });


    } catch (err) {


      const status = err?.response?.status;


      const messages = {
        401: "Fel e-post eller lösenord.",
        403: "Kontot väntar på godkännande."
      };


      setError(
        messages[status] ?? "Inloggningen misslyckades."
      );


    } finally {

      setLoading(false);

    }

  }





  return (

    <form
      onSubmit={handleLogin}
      className="space-y-6"
    >



      {error && (

        <div
          className="
            rounded-xl
            border
            border-red-200
            bg-red-50
            px-4
            py-3
            text-sm
            text-red-700
          "
        >
          {error}
        </div>

      )}






      <div>

        <label
          className="
            block
            mb-2
            text-sm
            font-semibold
            text-neutral-900
          "
        >
          E-post
        </label>


        <input
          type="email"
          autoComplete="email"
          placeholder="namn@exempel.se"
          value={email}
          onChange={(e) => setEmail(e.target.value)}

          className="
            w-full
            rounded-xl
            border
            border-neutral-200
            bg-white
            px-4
            py-3
            text-neutral-900

            placeholder:text-neutral-400

            outline-none
            transition

            focus:border-[#3BAFA3]
            focus:ring-4
            focus:ring-[#3BAFA3]/20
          "
        />

      </div>







      <div>

        <label
          className="
            block
            mb-2
            text-sm
            font-semibold
            text-neutral-900
          "
        >
          Lösenord
        </label>


        <input
          type="password"
          autoComplete="current-password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}

          className="
            w-full
            rounded-xl
            border
            border-neutral-200
            bg-white
            px-4
            py-3
            text-neutral-900

            placeholder:text-neutral-400

            outline-none
            transition

            focus:border-[#3BAFA3]
            focus:ring-4
            focus:ring-[#3BAFA3]/20
          "
        />

      </div>








      <button
        disabled={loading}
        type="submit"

        className="
          w-full
          rounded-xl
          bg-neutral-900
          py-3

          font-semibold
          text-white

          transition
          duration-200

          hover:bg-[#3BAFA3]

          disabled:cursor-not-allowed
          disabled:opacity-50
        "
      >

        {loading ? "Loggar in..." : "Logga in"}

      </button>







      <p
        className="
          text-center
          text-sm
          text-neutral-500
          pt-2
        "
      >

        Har du problem med kontot?


        <span
          className="
            ml-1
            cursor-pointer
            font-medium
            text-neutral-900

            hover:text-[#3BAFA3]
            hover:underline
          "
        >
          Kontakta support
        </span>


      </p>



    </form>

  );

}